'use client';

import { SearchLineModalMobile as BaseSearchLineModalMobile } from '@org/ui';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import SearchLine from '@/components/Search/SearchLine';
import { useLanguage } from '@/lib/config/useLanguage';

export default function SearchLineModalMobile() {
    const { t, tf } = useLanguage();

    const translations = {
        search: t('search', 'common'),
        placeholder: tf('placeholders', 'search'),
    };

    return (
        <BaseSearchLineModalMobile
            Dialog={Dialog}
            DialogContent={DialogContent}
            DialogTitle={DialogTitle}
            Button={Button}
            translations={translations}
            triggerClassName="bg-gray-50 md:hidden rounded-full"
        >
            <SearchLine />
        </BaseSearchLineModalMobile>
    );
}
